module.exports = __webpack_public_path__ + "img/d-zhcg.220aaab1.png";